import { gql, TypedDocumentNode } from '@common/hooks';
import {
  PerformToggleSubmissionsPausedMutationMutationCgResponse,
  PerformToggleSubmissionsPausedMutationMutationVariables,
} from '@common/graphql';

export const PERFORM_TOGGLE_SUBMISSIONS_PAUSED_MUTATION: TypedDocumentNode<
  PerformToggleSubmissionsPausedMutationMutationCgResponse,
  PerformToggleSubmissionsPausedMutationMutationVariables
> = gql`
  mutation PerformToggleSubmissionsPausedMutation($staffingRequestId: ID!) {
    toggleSubmissionsPaused(staffingRequestId: $staffingRequestId) {
      staffingRequest {
        id
        submissionsPaused
      }
    }
  }
`;
